import React from "react";
import styled from "styled-components";

import Text from "./Text";
import Logo from "../header/components/Logo";
import { style } from "./headings/H1";

import theme from "../../styles/theme";
import HTMLWrapper from "./HTMLWrapper";

const {
	font,
	colors,
	breakPoints: { mobileFirstScreenQuery },
} = theme;

const StatBlockStyle = styled.div`
	display: flex;
	flex-direction: column;
	padding: ${(props) => (props.styleType === "box" ? "40px" : "0 30px")};
	margin: ${(props) => props.styleType === "line" && "40px"};
	border-left: ${(props) => props.styleType === "line" && `2px solid ${colors.newBrand.coolGrey}`};
	color: ${colors.newBrand.coolGrey};

	> * {
		margin: 5px 0;
	}

	div {
		display: flex;
		flex-direction: column;
	}
	.stat {
		font-size: 48px;
		font-family: ${font.recoleta};
		line-height: 65px;
		letter-spacing: 0.01em;
	}
	.callout p,
	.callout p:not([class^="Body"]):not([class^="AllCaps"]) {
		font-family: ${font.bold};
		font-size: 14px;
		line-height: 13px;
		color: ${colors.newBrand.coolGrey};
		letter-spacing: 0.2em;
		text-transform: uppercase;
	}

	img {
		width: 60%;
		margin: 16px auto;
		${mobileFirstScreenQuery.large} {
			margin: 16px 0;
			width: 30%;
		}
	}
`;

const StatBlock = ({ statSection, styleType, logo, individualStat, individualStatDescription, className, ...props }) => {
	return (
		<StatBlockStyle styleType={styleType} className={`stat-block ${className}`} {...props}>
			{logo && <img src={logo} />}

			{statSection ? (
				statSection.map((individualStat) => {
					return (
						<div>
							<span className="stat">{individualStat?.stat}</span>
							<span className="callout">{individualStat?.description}</span>
						</div>
					);
				})
			) : (
				<div>
					<span className="stat">{individualStat}</span>
					<span className="callout">
						<HTMLWrapper html={individualStatDescription} />
					</span>
				</div>
			)}
		</StatBlockStyle>
	);
};

export default StatBlock;
